import { render, staticRenderFns } from "./TableManager.vue?vue&type=template&id=24ae4eda&scoped=true&"
import script from "./TableManager.vue?vue&type=script&lang=ts&"
export * from "./TableManager.vue?vue&type=script&lang=ts&"
import style0 from "./TableManager.vue?vue&type=style&index=0&id=24ae4eda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ae4eda",
  null
  
)

export default component.exports